<template>
  <div v-if="flagBuild">
    <v-row dense class="text-left mt-4">
      <v-col cols="12" sm="12" md="12"
        ><v-banner
          color="primary"
          dark
          class="mb-4"
          shaped
          single-line
          align="left"
        >
          <v-icon>mdi-information-outline</v-icon> Información de estudio
        </v-banner>
      </v-col>
    </v-row>
    <v-row dense class="ml-2">
      <v-col md="4" sm="12" cols="12">
        <strong>Id Estudio: </strong>
        <span class="error--text"> {{ fillinfo.idStudy }} </span>
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Estudio: </strong>
        {{ study }}
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Modalidad: </strong>
        {{ modality }}
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Fecha de solicitud: </strong>
        {{ fillinfo.registrationDate }}
      </v-col>
      <!-- <v-col  md="4" sm="12" cols="12">
        <strong >Estatus: </strong>
        {{ fillinfo.statusName }}
      </v-col> -->
    </v-row>
    <v-row dense class="ml-2" v-if="viewObservation">
      <v-col md="12" sm="12" cols="12">
        <strong>Observaciones: </strong>
        <span> {{ fillinfo.observation }} </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AppointmentInfoService } from "@/app/services";

export default {
  name: "AppointmentInformation",
  props: {
    model: Object,
    // flagComponents: Boolean,
  },
  data() {
    return {
      fillinfo: {},
      startTime: "",
      flagBuild: false,
      study: "",
      modality: "",
      viewObservation: false,
    };
  },
  mounted() {
    this.getInfo();
  },
  // watch: {
  //   flagComponents: function() {
  //     console.log("yes");
  //     if (this.flagComponents) {
  //       this.getInfo();
  //     }
  //   },
  // },
  methods: {
    async getInfo() {
      this.fillinfo = {};
      let params = {
        idStudy: this.model.idStudy,
      };
      await AppointmentInfoService.getStudyInformations(params)
        .then((response) => {
          let { data } = response;
          this.fillinfo = data;
          if (this.fillinfo.studyModality.acronym == null) {
            this.study = this.fillinfo.studyModality.name;
          } else {
            this.study =
              this.fillinfo.studyModality.acronym +
              " - " +
              this.fillinfo.studyModality.name;
          }
          if (this.fillinfo.modality.acronym == null) {
            this.modality = this.fillinfo.modality.name;
          } else {
            this.modality =
              this.fillinfo.modality.acronym +
              " - " +
              this.fillinfo.modality.name;
          }
          this.flagBuild = true;
          this.startTime = this.$utilFront.formatDateTime(
            this.fillinfo.startDate
          );
          this.fillinfo.registrationDate = this.$utilFront.formatDateTime(
            this.fillinfo.registrationDate
          );
          this.viewObservation = this.validateObservation();
        })
        .catch((e) => {
          this.$utilFront.errorhttp(e);
        });
    },
    validateObservation() {
      return (
        this.$utilFront.nonEmpty(this.fillinfo.observation) &&
        this.fillinfo.speciality.idSpeciality === this.$cnst.SPECIALITY_IMAGE &&
        this.fillinfo.status >= this.$cnst.STUDY_CLOSING.status
      );
    },
  },
};
</script>

<style></style>
